module.exports = __webpack_public_path__ + "static/media/rock-fact.109163e7.png";